import { render, staticRenderFns } from "./VacanciesBreakdown.vue?vue&type=template&id=7f5d4f07&scoped=true"
import script from "./VacanciesBreakdown.vue?vue&type=script&lang=js"
export * from "./VacanciesBreakdown.vue?vue&type=script&lang=js"
import style0 from "./VacanciesBreakdown.vue?vue&type=style&index=0&id=7f5d4f07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5d4f07",
  null
  
)

export default component.exports